<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="w-160" v-if="showDept">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item class="select_btn_160" v-if="onlineLearn == 1">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineLearnStatus"
        placeholder="在线课件学习情况"
      >
        <el-option
          v-for="(item, i) in learnData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item 
      v-if="childNum > 0" 
      class="select_btn m-l-14">
      <el-select
        class="select_btn_style"
        v-model="filters.smallClassId"
        placeholder="小班名称"
        
      >
        <el-option
          v-for="(item, i) in smallClassNameList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn_140 m-l-14" v-if="isParty == 1">
      <el-select
        class="select_btn_style"
        v-model="filters.enrollPushStatus"
        placeholder="党校同步状态"
      >
        <el-option
          v-for="(item, i) in syncStatusData.slice(
            0,
            syncStatusData.length - 1
          )"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-checkbox border v-model="filters.isPost" @change="checkChange"
        >只看班委</el-checkbox
      >
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.graduationStatus"
        placeholder="结业状态"
      >
        <el-option
          v-for="(item, i) in graduationStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名/手机号/房间号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree ref="lazyTree" :classId="classId" :defaultCheckedKeys="defaultCheckedKeys" :showModal="deptDialog" @deptSelected="selectDept" showTooltip/>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
import SingleCheckTree from "./singleCheckTree.vue";
export default {
  components: { butn, SingleCheckTree },
  props: {
    isParty: {
      type: String,
      default: "0",
    },
    smallClassNameList: {
      type: Array,
      default: () => [],
    },
    childNum: {
      type: Number,
      default: 0,
    },
    onlineLearn: {
      default: 0,
    },
    showDept: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        isPost: false,
      },
      graduationStatusData: [],
      syncStatusData: [],
      learnData: [],
      deptName: '',
      deptDialog: {
        flag: false
      },
      defaultCheckedKeys:[],
      classId: '',
    };
  },
  created() {
    this.classId = this.$route.query.id || '';
    this.getSysParamByTypes(["CLASS_FINISH_STATUS", "CLASS_PUSH_STATUS", "FINISH_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        let data = JSON.parse(JSON.stringify(res.data));
        this.$emit("setGraduationStatusData", data["CLASS_FINISH_STATUS"]);
        res.data["CLASS_FINISH_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["CLASS_PUSH_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["FINISH_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.graduationStatusData = res.data["CLASS_FINISH_STATUS"];
        this.syncStatusData = res.data["CLASS_PUSH_STATUS"];
        this.learnData = res.data['FINISH_STATUS']
      });
    },
    checkChange() {
      this.initData();
    },
    initData() {
      // , t: new Date().getTime()
      this.$emit("search", {
        ...this.filters,
        isPost: this.filters.isPost ? 1 : 0,
      });
    },
    resetData() {
      this.deptName = '';
      this.filters = { isPost: 0 };
      this.initData();
    },
     // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["deptTree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["deptTree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  // text-align: right;
  .w-160 {
    width: 160px;
    // margin-right: 12px;
  }
}
</style>
